<template>
  <ul class="list-manual-providers">
    <li
      v-for="provider in providersWithLogo"
      :key="provider.id"
      :class="[
        'list-manual-providers__item',
        { 'list-manual-providers__item_active': activeProvider?.id === provider.id },
      ]"
    >
      <button
        type="button"
        :class="[
          'list-manual-providers__provider',
          {
            'list-manual-providers__provider_active': activeProvider?.id === provider.id,
          },
        ]"
        @click.prevent="selectProvider(provider)"
      >
        <atomic-image :src="provider.img" :height="20" />
      </button>
    </li>
  </ul>
</template>

<script lang="ts" setup>
  import type { IManualProvider } from '@skeleton/core/types';

  const emit = defineEmits(['update:activeProvider']);

  const {
    public: { gamehubCdn },
  } = useRuntimeConfig();

  const { providers } = defineProps<{
    providers: IManualProvider[];
    activeProvider: IManualProvider | null;
  }>();

  const providersWithLogo = computed(() => {
    const colorMode = useColorMode();

    return providers.map(item => ({
      ...item,
      img: `${gamehubCdn}/payments/providers/${item.name.toLowerCase()}${colorMode.value === 'dark' ? '-dark' : ''}.svg`,
    }));
  });

  const selectProvider = (provider: IManualProvider) => {
    emit('update:activeProvider', provider);
  };
</script>

<style src="~/assets/styles/components/list/manual-providers.scss" lang="scss" />
